module.exports = __webpack_public_path__ + "static/media/1-check.d08d65f1.svg";